import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Eyes_6 = ({ eyeColours, skinColours }) => {
  const colour0 = '#F15743';
  const colour1 = '#FFFEF0';
  const colour2 = '#F6E7D0';
  const colour3 = eyeColours.shadow;
  const colour4 = '#DF5656';
  const colour5 = skinColours.shadow;

  return (
    <>
      <g>
        <g>
          <path
            fill={colour0}
            opacity={0.5}
            d="M310.9,371.3c-2.9-2-6.5-7.3-6.3-8.5c0.2-1.2,14.2-7.3,14.2-7.3L310.9,371.3z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M368,397.3c3.7,0.5,10.1-1,10.7-2.1c0.6-1.1-4.4-14.3-4.4-14.3L368,397.3z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M372.7,392.9c7.1-19-2-41.3-19.2-47.7c-17.2-6.5-37,3.7-44.1,22.7c-7.1,19,1.1,39.6,18.3,46.1
			C344.9,420.4,365.6,411.9,372.7,392.9z"
          />
          <path
            fill={colour1}
            d="M369.1,390.2c6.9-18.3-0.3-38-16.1-43.9c-15.8-5.9-34.1,4.2-41,22.5c-6.9,18.3,1.5,34.8,17.3,40.7
			C345.1,415.5,362.3,408.6,369.1,390.2z"
          />
          <path
            fill={colour2}
            d="M332.5,405.9c-15.8-5.9-23.8-23.3-17-41.6c1.1-3,2.5-5.7,4.2-8.2c-3.2,3.6-5.8,7.9-7.7,12.7
			c-6.9,18.3,1.2,35.7,17,41.6c13.4,5,28,0.1,36.4-12.7C356.8,407.1,344.2,410.3,332.5,405.9z"
          />
          <path
            fill={colour3}
            d="M356.4,380.4c2.3-7.5-1.6-15.3-8.7-17.4c-7.1-2.1-14.6,2.2-16.9,9.7c-2.3,7.5,1.6,15.3,8.7,17.4
			C346.6,392.2,354.2,387.9,356.4,380.4z"
          />
          <path
            fill={colour4}
            opacity={0.5}
            d="M378.8,395c-1.2-19.3-6.6-39.7-24.1-46.2c-15.8-5.9-40.8-0.4-49.3,14.1C328.7,363.3,365.4,376,378.8,395z"
          />
          <path
            fill={colour1}
            d="M353.1,388.3c2-2,2.4-4.9,0.8-6.5c-1.6-1.6-4.5-1.2-6.5,0.8c-2,2-2.4,4.9-0.8,6.5
			C348.2,390.7,351.1,390.3,353.1,388.3z"
          />
          <path
            fill={colour1}
            d="M355.3,377c-0.1-0.9-0.9-1.5-1.9-1.4c-1,0.1-1.7,0.9-1.6,1.7c0.1,0.9,0.9,1.5,1.9,1.4
			C354.7,378.6,355.4,377.8,355.3,377z"
          />
          <path
            fill={colour5}
            d="M307.4,360.1c6.3-6.9,51.9-11,71,31c0,0,6.7-35.9-22.8-46.9C321.4,331.4,307.4,360.1,307.4,360.1z"
          />
          <path
            fill={colour5}
            d="M308.3,356.4c-2.4,3.7-3.6,6.3-3.6,6.3c6.5-7.2,50.9,0.1,74.1,32.4c0,0,0.5-2.3,1.1-5.9
			C360.8,352,321.7,351.1,308.3,356.4z"
          />
        </g>
        <g>
          <path
            fill={colour0}
            opacity={0.5}
            d="M499.3,394.4c3.2-1.3,7.9-5.6,7.9-6.9c0-1.3-11.8-10.3-11.8-10.3L499.3,394.4z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M439.2,406.9c-3.6-0.4-9.3-3.3-9.7-4.5c-0.4-1.2,7.4-12.9,7.4-12.9L439.2,406.9z"
          />
          <path
            fill={colour0}
            opacity={0.5}
            d="M435.8,401.5c-2.4-20.1,11.4-39.7,29.2-42.1c17.8-2.4,34.2,11.9,36.5,32c2.4,20.1-10.2,38.3-28,40.7
			C455.7,434.5,438.1,421.6,435.8,401.5z"
          />
          <path
            fill={colour1}
            d="M439.8,399.7c-2.3-19.4,9.1-36.9,25.4-39.1c16.3-2.2,31.4,11.7,33.6,31.1c2.3,19.4-9.5,33.5-25.8,35.7
			C456.7,429.7,442.1,419.1,439.8,399.7z"
          />
          <path
            fill={colour2}
            d="M470.9,423.2c16.3-2.2,27.9-17.3,25.7-36.7c-0.4-3.1-1.1-6.1-2.1-8.9c2.2,4.2,3.7,9,4.3,14.1
			c2.3,19.4-9.4,34.5-25.7,36.7c-13.9,1.9-26.6-6.2-31.5-20.5C447.6,418.9,458.8,424.8,470.9,423.2z"
          />
          <path
            fill={colour3}
            d="M454.1,393c-0.4-7.8,5.1-14.5,12.2-15c7.2-0.5,13.3,5.4,13.8,13.2c0.4,7.8-5.1,14.5-12.2,15
			C460.7,406.7,454.5,400.8,454.1,393z"
          />
          <path
            fill={colour4}
            opacity={0.5}
            d="M429.5,402.2c5.6-18.6,15.4-37.1,33.5-39.6c16.3-2.2,38.7,8.8,43.5,24.7C484.2,382.6,446.6,386.7,429.5,402.2
			z"
          />
          <path
            fill={colour1}
            d="M474.4,394.7c-0.2-2.9,1.5-5.3,3.6-5.4c2.2-0.1,4,2,4.2,4.9c0.2,2.9-1.5,5.3-3.6,5.4
			C476.5,399.8,474.6,397.6,474.4,394.7z"
          />
          <path
            fill={colour1}
            d="M475.4,387.6c-0.8-0.2-1.5-1.1-1.6-2c0-0.9,0.6-1.5,1.5-1.3c0.8,0.2,1.5,1.1,1.6,2
			C476.9,387.2,476.2,387.8,475.4,387.6z"
          />
          <path
            fill={colour5}
            d="M505.2,384.2c-4.4-8.1-46.7-22.4-74.5,14.3c0,0,1.9-36.4,32.4-40.5C498.5,353.2,505.2,384.2,505.2,384.2z"
          />
          <path
            fill={colour5}
            d="M505.2,380.4c1.4,4.1,1.9,6.9,1.9,6.9c-4.5-8.4-48.2-11.3-77.6,14.9c0,0,0-2.3,0.3-6
			C456.5,364.4,493.7,372.3,505.2,380.4z"
          />
        </g>
      </g>
    </>
  );
};

export default Eyes_6;
